import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchResultCard } from "./SearchResultCard";
import cn from "classnames";
export const SearchResultsList = (props) => {
    const { results, view } = props;
    const isInstanceGeneric = (result) => {
        return "readMoreLink" in result && typeof result.readMoreLink === "string";
    };
    const isInstanceEvent = (result) => {
        return "dateTime" in result;
    };
    const isInstanceInsight = (result) => {
        return "date" in result || "imageURL" in result;
    };
    const isCardTypeEqual = (cardType) => {
        return (resultCardType) => {
            return resultCardType === cardType;
        };
    };
    const isCardGeneric = isCardTypeEqual("Generic");
    const isCardEvent = isCardTypeEqual("EventsAndWebinars");
    const isCardInsight = isCardTypeEqual("Insight");
    const renderDynamicCard = (result) => {
        const { data, cardType } = result;
        if (isInstanceGeneric(data) && isCardGeneric(cardType)) {
            return _jsx(SearchResultCard.Generic, { ...data });
        }
        if (isInstanceEvent(data) && isCardEvent(cardType)) {
            return _jsx(SearchResultCard.EventWebinar, { ...data });
        }
        if (isInstanceInsight(data) && isCardInsight(cardType)) {
            return _jsx(SearchResultCard.Insight, { ...data });
        }
        return _jsx(SearchResultCard.Generic, { ...data });
    };
    const mapToListItem = (result) => {
        const { data, cardType } = result;
        if (isInstanceEvent(data) && isCardEvent(cardType)) {
            return {
                ...data,
                readMoreLink: data.link
            };
        }
        // add additional conditions if necessary for mapping
        return data;
    };
    const shouldDisplayGrid = !!results.length && view === "grid";
    const shouldDisplayList = !!results.length && view === "list";
    return (_jsxs(_Fragment, { children: [results.map((item, index) => (_jsx("article", { className: "search-results-card hidden lg:flex", children: shouldDisplayGrid && renderDynamicCard(item) }, `${item.cardType}-${index}`))), results
                .map((result) => mapToListItem(result))
                .map((item, index) => (_jsx("article", { className: cn("search-results-list-item flex", { flex: shouldDisplayList, "lg:hidden": shouldDisplayGrid }), children: _jsx(SearchResultCard.ListItem, { ...item }) }, `${item.title}-${index}`)))] }));
};
